import React from "react";
import { HomePageLayout } from "../HomePageLayout";
import _ from "lodash";
import corporateType1ImageSrc from "./images/corporateType1.png";
import corporateType2ImageSrc from "./images/corporateType2.png";
import corporateType3ImageSrc from "./images/corporateType3.png";
import { Col, Row } from "antd";
import "./index.scss";

interface IPlanItem {
  title: string;
  description: string;
  imageSrc: string;
}

const planItems: ReadonlyArray<IPlanItem> = [
  {
    title: "分销伙伴",
    description:
      "在行业或区域内具备独立销售依图产品和服务，并与依图共同拓展市场的合作伙伴。",
    imageSrc: corporateType1ImageSrc
  },
  {
    title: "行业伙伴",
    description:
      "拥有行业业务基础和项目储备量，并具备整合依图产品和技术能力的合作伙伴。",
    imageSrc: corporateType2ImageSrc
  },
  {
    title: "解决方案伙伴",
    description:
      "具备自主开发或集成能力，并能将自身产品与依图AI产品服务相结合，为客户提供基于依图AI能力的通用型行业解决方案。",
    imageSrc: corporateType3ImageSrc
  }
];

export class CorporatePlanWall extends React.PureComponent {
  planRender(planItem: IPlanItem) {
    const cls = "CorporatePlanItem";
    const { description, imageSrc, title } = planItem;

    return (
      <div className={`${cls}`} key={title}>
        <img className={`${cls}-image`} src={imageSrc} />
        <div className={`${cls}-title`}>{title}</div>
        <div className={`${cls}-description`}>{description}</div>
      </div>
    );
  }

  render() {
    return (
      <HomePageLayout title="成为依图伙伴">
        <Row gutter={16}>
          {_.map(planItems, (planItem, idx) => (
            <Col xs={8} md={8} key={idx}>
              {this.planRender(planItem)}
            </Col>
          ))}
        </Row>
      </HomePageLayout>
    );
  }
}
